/**
 * Product Card ATC - mobile quick add to cart on collection/featured grids
 * Uses same logic as predictive search ATC
 */
(function () {
  'use strict';

  var toastHideTimer = null;

  function isMobileViewport() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
  }

  function ensureToast() {
    var toast = document.getElementById('pca-added-toast');
    if (toast) { return toast; }

    toast = document.createElement('a');
    toast.id = 'pca-added-toast';
    toast.className = 'pca-toast';
    toast.href = '/cart';
    toast.setAttribute('aria-label', 'Added to cart. Open cart');
    toast.innerHTML = ''
      + '<span class="pca-toast__icon" aria-hidden="true">'
      + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'
      + '<circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>'
      + '</svg>'
      + '</span>'
      + '<span class="pca-toast__text">Added to cart</span>';

    document.body.appendChild(toast);
    return toast;
  }

  function showAddedToast() {
    if (!isMobileViewport()) { return; }

    var toast = ensureToast();
    clearTimeout(toastHideTimer);
    toast.classList.remove('is-visible');

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.classList.add('is-visible');
      });
    });

    toastHideTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 1850);
  }

  function handleAtc(btn) {
    var handle = btn.dataset.handle;
    if (btn.disabled) { return; }
    if (btn.__pcaProduct) {
      addProduct(btn.__pcaProduct, btn);
      return;
    }
    if (!handle) { return; }
    btn.disabled = true;
    btn.classList.add('pca--loading');

    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        addProduct(product, btn);
      })
      .catch(function () {
        btn.classList.remove('pca--loading');
        btn.disabled = false;
      });
  }

  function addProduct(product, btn) {
    var variants = product && product.variants ? product.variants : [];
    var avail = variants.filter(function (v) { return v.available; });
    var pool = avail.length ? avail : variants;

    if (btn) {
      btn.disabled = true;
      btn.classList.add('pca--loading');
    }

    if (pool.length === 1) {
      return doAdd(pool[0].id, btn);
    } else if (pool.length > 1) {
      if (btn) {
        btn.classList.remove('pca--loading');
        btn.disabled = false;
      }
      showPicker(product, pool, btn);
      return null;
    }

    if (btn) {
      btn.classList.remove('pca--loading');
      btn.disabled = false;
    }
    return null;
  }

  function doAdd(variantId, btn) {
    var label = btn ? btn.querySelector('[data-pca-label]') : null;
    var originalLabel = label ? label.textContent : '';
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (data) { throw data; });
        }
        return r.json();
      })
      .then(function () {
        showAddedToast();

        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('#CartCount,#DesktopStickyCartCount,.mobile-header__cart-count,.cart-count')
            .forEach(function (el) { el.textContent = c.item_count; });
        });

        if (btn) {
          btn.classList.remove('pca--loading');
          btn.classList.add('pca--success');
          if (label && btn.dataset.successText) { label.textContent = btn.dataset.successText; }
          setTimeout(function () {
            btn.classList.remove('pca--success');
            btn.disabled = false;
            if (label && originalLabel) { label.textContent = originalLabel; }
          }, 1800);
        }
      })
      .catch(function () {
        if (btn) {
          btn.classList.remove('pca--loading');
          btn.disabled = false;
          if (label && originalLabel) { label.textContent = originalLabel; }
        }
      });
  }

  function showPicker(product, variants, triggerBtn) {
    var existing = document.getElementById('pca-picker-overlay');
    if (existing) { existing.parentNode.removeChild(existing); }

    var overlay = document.createElement('div');
    overlay.id = 'pca-picker-overlay';
    overlay.className = 'pca-picker-overlay';
    var overlayZIndex = triggerBtn && triggerBtn.closest && triggerBtn.closest('.longoni-lightbox') ? 2147483001 : 999999;
    overlay.style.cssText = 'position:fixed;inset:0;z-index:' + overlayZIndex + ';background:rgba(0,0,0,0);display:flex;align-items:flex-end;transition:background .2s ease';

    var sheet = document.createElement('div');
    sheet.className = 'pca-picker-sheet';
    sheet.style.cssText = 'width:100%;background:#fff;border-radius:20px 20px 0 0;padding-bottom:env(safe-area-inset-bottom,16px);transform:translateY(100%);transition:transform .28s cubic-bezier(.33,1,.68,1);box-shadow:0 -8px 32px rgba(0,0,0,.15);max-height:70vh;overflow-y:auto';

    var opts = variants.map(function (v) {
      var price = v.price ? ' - $' + (v.price / 100).toFixed(2) : '';
      return '<option value="' + v.id + '">' + esc(v.title) + price + '</option>';
    }).join('');

    sheet.innerHTML =
      '<div class="pca-picker-handle" style="width:40px;height:4px;background:rgba(0,0,0,.15);border-radius:2px;margin:12px auto 0"></div>'
      + '<div class="pca-picker-header" style="display:flex;align-items:center;justify-content:space-between;padding:12px 20px 10px;border-bottom:1px solid rgba(0,0,0,.07)">'
      + '<span class="pca-picker-title" style="font-size:15px;font-weight:600;flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">' + esc(product.title) + '</span>'
      + '<button id="pca-picker-close" class="pca-picker-close" type="button" style="width:30px;height:30px;border-radius:50%;border:none;background:rgba(0,0,0,.07);cursor:pointer;flex-shrink:0;display:flex;align-items:center;justify-content:center">'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" width="16" height="16"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button></div>'
      + '<div style="padding:16px 20px">'
      + '<label style="display:block;font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#888;margin-bottom:8px">Choose option</label>'
      + '<select id="pca-picker-select" style="width:100%;padding:12px 16px;font-size:15px;border:1.5px solid rgba(0,0,0,.15);border-radius:10px;background:#f5f5f5;-webkit-appearance:none;appearance:none;outline:none">' + opts + '</select></div>'
      + '<div style="padding:0 20px 4px">'
      + '<button id="pca-picker-confirm" type="button" style="width:100%;padding:14px;font-size:16px;font-weight:600;color:#fff;background:#1a1a1a;border:none;border-radius:12px;cursor:pointer">Add to Cart</button></div>';

    overlay.appendChild(sheet);
    document.body.appendChild(overlay);

    requestAnimationFrame(function () {
      overlay.style.background = 'rgba(0,0,0,.45)';
      sheet.style.transform = 'translateY(0)';
    });

    function close() {
      overlay.style.background = 'rgba(0,0,0,0)';
      sheet.style.transform = 'translateY(100%)';
      setTimeout(function () {
        if (overlay.parentNode) { overlay.parentNode.removeChild(overlay); }
      }, 260);
    }

    document.getElementById('pca-picker-close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) { close(); } });
    document.getElementById('pca-picker-confirm').addEventListener('click', function () {
      var sel = document.getElementById('pca-picker-select');
      if (sel && sel.value) {
        doAdd(sel.value, triggerBtn);
        close();
      }
    });
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  window.ProductCardATC = window.ProductCardATC || {};
  window.ProductCardATC.addProduct = addProduct;
  window.ProductCardATC.addVariant = doAdd;
  window.ProductCardATC.showPicker = showPicker;
  window.ProductCardATC.handleButton = handleAtc;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-card-atc');
    if (btn) {
      e.preventDefault();
      handleAtc(btn);
    }
  });
})();
